<template>
  <div
    class="merchSubCategoryV3"
    data-testid="sbx-pcc_merchSubCatV3"
    v-if="items && items.length"
  >
    <div class="merchSubCategoryV3_heading">
      <h3
        class="merchSubCategoryV3_title"
        :class="{ 'has-sub': this.subtitle }"
        v-if="this.title"
        v-html="this.title"
      ></h3>
      <p
        class="merchSubCategoryV3_subtitle"
        v-if="this.subtitle"
        v-html="this.subtitle"
      ></p>
    </div>

    <ul class="merchSubCategoryV3__list">
      <li
        class="merchSubCategoryV3__item"
        v-for="(item, index) in this.items"
        :key="`merchSubCategoryV3-${index}`"
        :test-id="`sbx-pcc_merchSubCategoryV3--${index}`"
      >
        <a
          :href="baseUrl() + item.link"
          :data-testid="`sbx-pcc_merchSubCategoryV3-link-${index}`"
          :title="item.label"
        >
          <img
            :src="propsByScreenSize.image[index] + imageParameters"
            class="merchSubCategoryV3__image"
            :alt="item.label"
            :data-testid="`sbx-pcc_merchSubCategoryV3-image-${index}`"
          />
          <div class="merchSubCategoryV3__item-title">{{ item.label }}</div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { merchSubCategoryV3 } from './index.js'
import { baseUrl } from '@/SharedFe/utils/urlUtils'

export default {
  name: 'merchSubCategoryV3',
  props: {
    ...merchSubCategoryV3.propTypes,
    screenSize: String,
  },
  data() {
    return {
      baseUrl,
    }
  },
  computed: {
    propsByScreenSize() {
      const image = this.items.map(function (itm) {
        return Object.keys(itm.images).includes(this.screenSize)
          ? itm.images[this.screenSize]
          : itm.images.base
      }, this)
      return {
        image,
      }
    },
    imageParameters() {
      switch (this.screenSize) {
        case 'contained':
          return '?thumbor=272x144'
        case 'mobile':
          return '?thumbor=194x144'
        default:
          return ''
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/SharedFe/scss/variables.scss';
@import '@/SharedFe/scss/typography.scss';

$medium-up: 'only screen and (min-width: 768px)';
$large-up: 'only screen and (min-width: 1024px)';

.merchSubCategoryV3 {
  margin: 0 rem-calc(16);
  @media #{$large-up} {
    margin: 0;
  }

  &_title {
    margin: rem-calc(4) 0 rem-calc(12) 0;
    text-align: center;
    @media #{$large-up} {
      margin: rem-calc(4) 0 rem-calc(20) 0;
    }

    &.has-sub {
      margin: rem-calc(4) 0;
    }
  }

  &_subtitle {
    margin: rem-calc(4) 0 rem-calc(8) 0;
    text-align: center;
    @media #{$large-up} {
      margin: rem-calc(4) 0 rem-calc(20) 0;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 0;
    justify-content: space-between;
    overflow: hidden;
    margin: 0 rem-calc(-9);
    @media #{$medium-up} {
      margin: 0 rem-calc(-12.5);
    }
  }

  &__item {
    width: calc(50% - 18px);
    list-style-type: none;
    margin: 0 rem-calc(9) rem-calc(7);
    @media #{$medium-up} {
      width: calc(33.33% - 25px);
      margin: 0 rem-calc(12.5) rem-calc(7);
    }
    @media #{$large-up} {
      width: calc(100% / 6 - 25px);
    }

    & a {
      text-decoration: none;
    }

    &:hover {
      opacity: 0.7;

      & .merchSubCategoryV3__item-title {
        color: $brand-primary-color-1;
      }
    }
  }

  &__image {
    width: 100%;
    height: 8rem;
    border-radius: rem-calc(5);
    object-fit: contain;
    display: block;
    @media #{$medium-up} {
      height: 9rem;
    }
  }

  &__item-title {
    font-family: $brand-font-medium;
    font-size: 1rem;
    margin: rem-calc(9) 0;
    max-height: rem-calc(40);
    line-height: 1.3;
    color: $collection-black;
    text-align: center;
    text-decoration: none;
    overflow: hidden;
    @media #{$medium-up} {
      font-size: rem-calc(18);
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    @media #{$large-up} {
      font-size: rem-calc(21);
      max-height: rem-calc(57);
    }
  }
}
</style>
